import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';

// project import
import { useAppConfig } from 'contexts/ConfigContext';
import config from 'config';
import { GridType } from '../../graphql/types';
import useAuth from '../../hooks/useAuth';
import LogoIcon from './LogoIcon';
import LogoMain from './LogoMain';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => {
  const { user: currentUser } = useAuth();
  const userId = currentUser?.id;
  const keyName = `${userId}_${GridType.McaGrid}`;
  const { businessLogo, miniBusinessLogo } = useAppConfig();

  const miniLogo = miniBusinessLogo
    ? <img src={miniBusinessLogo} alt="Logo" style={{ height: 35, width: 'auto' }} />
      : <LogoIcon />;

  const mainLogo = businessLogo
      ? <img src={businessLogo} alt="Logo" style={{ height: 35, width: 'auto' }} />
      : <LogoMain reverse={reverse} />;
  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={!to ? config.defaultPath : to}
      sx={sx}
      onClick={() => {
        //TODO(WGF-399): find better solution
        localStorage.removeItem(keyName + '_FILTER_STATE');
      }}
    >
      {isIcon ? miniLogo : mainLogo}
    </ButtonBase>
  );
};

export default LogoSection;
